module.exports = "/assets/data/7e515c50c83e8cd364a234d7f09977b8-WA2.data.json";